export default {
  users: [],
  user: {}
}